// Supported languages
export const Language = {
  EN: 'en',
  DE: 'de',
  PT: 'pt-BR',
};
